import db from "@/libs/utils/db";
export default {
    namespaced: true,
    state: {
        user : [],
        paths : [],
        merchants:{},
        merchantsId : 0
    },
    actions: {
        /**
         * 设置用户ID
         * @param state
         * @param dispatch
         * @param info
         */
        setUser({ state, dispatch }, info) {
            state.user = info;
            db.setStorageSync("adminUser",info);
        },
        /**
         * 退出
         * @param state
         * @param dispatch
         * @param info
         */
        delUser({ state, dispatch }) {
            db.removeStorageSync("adminUser");
        },


        setpaths({ state, dispatch }, info) {
            state.paths = info;
            db.setStorageSync("adminPaths",info);
        },



    }
}
